/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APITypeEnum } from './APITypeEnum';
import {
    APITypeEnumFromJSON,
    APITypeEnumFromJSONTyped,
    APITypeEnumToJSON,
} from './APITypeEnum';

/**
 * Serializer for Ticket model.
 * @export
 * @interface APITicketRequest
 */
export interface APITicketRequest {
    /**
     * 
     * @type {string}
     * @memberof APITicketRequest
     */
    user?: string;
    /**
     * 
     * @type {APITypeEnum}
     * @memberof APITicketRequest
     */
    type: APITypeEnum;
    /**
     * 
     * @type {string}
     * @memberof APITicketRequest
     */
    subject: string;
    /**
     * 
     * @type {string}
     * @memberof APITicketRequest
     */
    message: string;
    /**
     * 
     * @type {boolean}
     * @memberof APITicketRequest
     */
    shared?: boolean;
}



/**
 * Check if a given object implements the APITicketRequest interface.
 */
export function instanceOfAPITicketRequest(value: object): value is APITicketRequest {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('subject' in value) || value['subject'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function APITicketRequestFromJSON(json: any): APITicketRequest {
    return APITicketRequestFromJSONTyped(json, false);
}

export function APITicketRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APITicketRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'user': json['user'] == null ? undefined : json['user'],
        'type': APITypeEnumFromJSON(json['type']),
        'subject': json['subject'],
        'message': json['message'],
        'shared': json['shared'] == null ? undefined : json['shared'],
    };
}

export function APITicketRequestToJSON(value?: APITicketRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'user': value['user'],
        'type': APITypeEnumToJSON(value['type']),
        'subject': value['subject'],
        'message': value['message'],
        'shared': value['shared'],
    };
}

